var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{attrs:{"id":"box"}},[_c('el-container',[_c('el-aside',{attrs:{"id":"leftNav","width":"256"}},[_c('Nav')],1),_c('el-container',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('el-header',{attrs:{"id":"header"}},[_c('Header')],1),_c('el-main',{attrs:{"id":"main"}},[_c('router-view',{key:_vm.key})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }